import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import type { FinalizeGorgiasDto } from "../generated/schema";

export default function useFinalizeGorgiasIntegration({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: Error) => void;
} = {}) {
	const mutation = $api.useMutation("post", "/gorgias/finalize");

	return useMutation({
		onSuccess,
		onError,
		mutationFn: async (data: FinalizeGorgiasDto) => {
			return mutation.mutateAsync({
				body: data,
			});
		},
	});
}
